export type Culture = "he-il" | "en-us" | "ar" | "ru"

type Locale = "he" | "en" | "ar" | "ru"

export const cultureMap: Record<string, Culture> = {
  he: "he-il",
  en: "en-us",
  ar: "ar",
  ru: "ru",
} as const

export function getDirection(locale: Locale) {
  return locale === "he" || locale === "ar" ? "rtl" : "ltr"
}
